import * as types from './referral.types';

const initState = {
    data:      null,
    error:     null,
    isLoading: false,
};

export function referralReducer(state = initState, action) {
    const { type, error, data } = action;

    switch (type) {
            case types.REFERRAL_GET_ERROR: {
                return {
                    ...state,
                    error,
                    data,
                    isLoading: false,
                };
            }

            case types.REFERRAL_GET_REQUEST: {
                return {
                    ...state,
                    isLoading: true,
                };
            }

            case types.REFERRAL_GET_SUCCESS: {
                return {
                    ...state,
                    data,
                    error:     null,
                    isLoading: false,
                };
            }

            default:
                return state;
    }
}
